export default function ToolTip({
  tooltipData,
  tooltipVisible,
  setTooltipVisible,
}) {
  return (
    <>
      {tooltipData && tooltipVisible && (
        <div
          // className={`tooltip ${tooltipVisible ? "visible" : ""}`}
          onClick={() => setTooltipVisible(false)}
          style={{
            // height:40,
            // width: 140,
            width: "20%",
            minWidth: 250,
            padding: "1%",
            borderRadius: 10,
            background: "#ff0a",
            position: "absolute",
            border: "1px solid black",
            // left: tooltipData.left-40,
            // left: "30%",
            left: tooltipData.left,
            // left: 55,
            // top: tooltipData.top+140,
            // top: "9%",
            top: tooltipData.top,
            // top: 70,
          }}
        >
          <h3>{tooltipData.district}</h3>
          <ol>
            {tooltipData?.events?.map((value, index) => {
              return (
                <>
                  <li key={index}>
                    <b>{value?.venue}</b>
                    <br />
                    <p>{value?.games?.join(", ")}</p>
                  </li>
                </>
              );
            })}
          </ol>
          {/* {tooltipData.name} */}
          {/* <br />
          {tooltipData.population} */}
        </div>
      )}
    </>
  );
}
